import { render } from "./Upload-image.vue?vue&type=template&id=4028e575&scoped=true"
import script from "./Upload-image.vue?vue&type=script&lang=js"
export * from "./Upload-image.vue?vue&type=script&lang=js"

import "./Upload-image.vue?vue&type=style&index=0&id=4028e575&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4028e575"]])

export default __exports__